import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'metismenu/dist/metisMenu.css';
import 'sweetalert/dist/sweetalert.css';
import 'animate.css/animate.css';
import 'lightbox2/dist/css/lightbox.css';
import 'toastr/build/toastr.css';
import './pe-icon-7-stroke/css/pe-icon-7-stroke.css';
import './pe-icon-7-stroke/css/helper.css';
import './less/style.less';
import './custom.css';



// WEBPACK FOOTER //
// ./styles/styles.js